import * as Types from "../constants/Module";
import { ViewState } from "redux/constants/App";
import { setBusy, setError, setReady } from "./utils";

const initialState = {
  modules: [],
  error: {
    status: null,
    message: null,
    errors: [],
  },
  module: {
    id: null,
    name: null,
    description: null,
    icon: null,
    route: null,
    breadcrumb: null,
    menu: null,
    submenu: null,
    moduleId: null,
  },
  postStatus: ViewState.IDLE,
  getStatus: ViewState.IDLE,
  getIdStatus: ViewState.IDLE,
  tablePath: "/admin/module",
};

const actions = {
  [Types.ADD_MODULE]: (state) => setBusy({ state, statusKey: "postStatus" }),
  [Types.ADD_MODULE_OK]: (state) =>
    setReady({ state, statusKey: "postStatus" }),
  [Types.ADD_MODULE_FAILED]: (state, error) =>
    setError({ state, statusKey: "postStatus", error }),

  [Types.FETCH_MODULES]: (state) => setBusy({ state, statusKey: "getStatus" }),
  [Types.FETCH_MODULES_FAILED]: (state, error) =>
    setError({ state, statusKey: "getStatus", error }),
  [Types.FETCH_MODULES_OK]: (state, modules) =>
    setReady({ state, statusKey: "getStatus", payload: { modules } }),

  [Types.FETCH_MODULE_ID]: (state) =>
    setBusy({ state, statusKey: "getIdStatus" }),
  [Types.FETCH_MODULE_ID_FAILED]: (state, err) =>
    setError({ state, statusKey: "getIdStatus", error: err }),
  [Types.FETCH_MODULE_ID_OK]: (state, module) =>
    setReady({ state, statusKey: "getIdStatus", payload: { module } }),

  [Types.PATCH_MODULE]: (state) => setBusy({ state, statusKey: "postStatus" }),
  [Types.PATCH_MODULE_OK]: (state) =>
    setReady({ state, statusKey: "postStatus" }),
  [Types.PATCH_MODULE_FAILED]: (state, error) =>
    setError({ state, statusKey: "postStatus", error }),
};

export default function (state = initialState, { type: actionType, payload }) {
  const action = actions[actionType];
  if (action) return action(state, payload);
  return state;
}
